import type { BobState } from "../types";

interface Props {
  state: BobState;
  onRefresh: () => void;
  onToggleAdapter: (id: string) => void;
}

export function SovereignRuntimePanel({ state, onRefresh, onToggleAdapter }: Props) {
  const s = state.sovereign;

  return (
    <section className="surface glass-panel gold-frame">
      <h2>Sovereign Runtime Status</h2>
      <p className="lead">No API Paywall Runtime — local deterministic core, optional adapters disabled by default.</p>
      <div className="btn-row" style={{ marginTop: 0 }}>
        <span className="chip locked">No API keys required</span>
        <span className="chip ok">{s.offlineCapable ? "Offline capable" : "Online only"}</span>
        <span className="chip locked">Paywall lock ON</span>
      </div>
      <div className="status-grid">
        <div className="status-card">
          <h3>Storage</h3>
          <div>{s.storageMode}</div>
        </div>
        <div className="status-card">
          <h3>Export</h3>
          <div>{s.exportMode}</div>
        </div>
        <div className="status-card">
          <h3>Last check</h3>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: "0.75rem" }}>{s.checkedAt}</div>
        </div>
      </div>
      <h3 style={{ marginTop: "1rem", fontSize: "0.95rem" }}>Adapters</h3>
      <div className="status-grid">
        {s.adapters.map((a) => (
          <div key={a.id} className="status-card">
            <h3>{a.name}</h3>
            <p style={{ margin: "0.25rem 0", fontSize: "0.8rem", color: "var(--text-muted)" }}>{a.description}</p>
            <div style={{ display: "flex", gap: "0.35rem", flexWrap: "wrap", marginTop: "0.35rem" }}>
              <span className={`chip ${a.enabled ? "ok" : ""}`}>{a.enabled ? "enabled" : "disabled"}</span>
              <span className="chip">{a.mode}</span>
            </div>
            {a.mode === "optional-adapter" && a.id !== "claude-handoff" && (
              <button
                type="button"
                className="btn secondary"
                style={{ marginTop: "0.5rem", fontSize: "0.75rem", padding: "0.35rem 0.6rem" }}
                onClick={() => onToggleAdapter(a.id)}
              >
                Toggle
              </button>
            )}
          </div>
        ))}
      </div>
      <div className="btn-row">
        <button type="button" className="btn secondary" onClick={onRefresh}>
          Refresh runtime status
        </button>
      </div>
    </section>
  );
}
